import React from "react";
import { Day, GenderRender, sepJustMoney, ToDateJalali } from "../../../Function";

const ItemProduct = ({ details }) => {
  const handlerData = KEY => {
    switch (KEY) {
      case "item_name":
        return {
          name: "نام مجموعه",
          value: details[KEY],
        };
      case "title":
        return {
          name: "عنوان شیفت",
          value: details[KEY],
        };
      case "gender":
        return {
          name: "جنسیت",
          value: GenderRender(details[KEY]),
        };
      case "start":
        return {
          name: "ساعت شروع",
          value: details[KEY],
        };
      case "end":
        return {
          name: "ساعت پایان",
          value: details[KEY],
        };
      case "day":
        return {
          name: "روز",
          value: Day(details[KEY]),
        };
      case "date":
        return {
          name: "تاریخ",
          value: ToDateJalali(details[KEY]),
        };
      case "second_price":
        return {
          name: "قیمت با تخفیف",
          value: sepJustMoney(details[KEY]) + " تومان",
        };
      case "price":
        return {
          name: "قیمت",
          value: sepJustMoney(details[KEY]) + " تومان",
        };
    }
  };
  return (
    <div style={{ marginBottom: "30px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        <h4 style={{ fontSize: "18px" }}>مشخصات مجموعه</h4>
      </div>
      <div className="row justify-content-between px-2">
        {Object.keys(details).map(function (value, key) {
          if (handlerData(value))
            return (
              <div
                key={key}
                className={`col-md-6 d-flex ${window.innerWidth > 600
                    ? "justify-content-start"
                    : "justify-content-between"
                  }   align-items-center `}
              >
                <div>
                  <span style={{ fontWeight: "500", fontSize: "14px" }}>
                    {handlerData(value)["name"]} :
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "400", fontSize: "14px", marginRight: "5px" }}>
                    {handlerData(value)["value"]}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default ItemProduct;
